import { createFileRoute } from "@tanstack/react-router";
import { PageHeader } from "@/client/components/page-header";
import { apiQuery, useApiSuspenseQuery } from "@/client/lib/api";
import { ensurePage, pageHead } from "@/client/lib/page";
import { ClinicCashPanel } from "@/client/modules/financeiro/clinica/clinic-cash-panel";
import { ClinicaPanel } from "@/client/modules/financeiro/clinica/clinica-panel";
import { DoctorFinancePanel } from "@/client/modules/financeiro/doctor/doctor-finance-panel";
import { FinanceiroTabs } from "@/client/modules/financeiro/financeiro-tabs";
import Loading from "@/client/modules/financeiro/loading";

type Search = {
  tab?: string;
  group?: string;
  from?: string;
  to?: string;
  kind?: string;
  status?: string;
  area?: string;
  year?: string;
  month?: string;
  category?: string;
};

const KEYS = ["tab", "group", "from", "to", "kind", "status", "area", "year", "month", "category"] as const;

export const Route = createFileRoute("/app/financeiro/")({
  validateSearch: (s: Record<string, unknown>): Search =>
    Object.fromEntries(KEYS.map((k) => [k, s[k] as string | undefined])) as Search,
  loaderDeps: ({ search }) => search,
  loader: ({ context, deps }) => ensurePage(context.queryClient, apiQuery("financeiro", "mainPage", deps)),
  head: () => pageHead("Financeiro"),
  pendingComponent: Loading,
  component: FinanceiroPage,
});

function FinanceiroPage() {
  const search = Route.useSearch();
  const { data } = useApiSuspenseQuery("financeiro", "mainPage", search);
  return (
    <div className="mx-auto flex max-w-7xl flex-col gap-6">
      <PageHeader title="Financeiro" description="Receita dos atendimentos e contas da clínica." />
      <FinanceiroTabs tabs={data.tabs} activeTabId={data.activeTabId} canSeeTotals={data.canSeeTotals}>
        {data.doctor ? (
          <DoctorFinancePanel key={data.doctor.doctorId} {...data.doctor} />
        ) : data.clinica ? (
          <div className="flex flex-col gap-6">
            {data.clinica.clinicRevenue && <ClinicCashPanel data={data.clinica.clinicRevenue} />}
            <ClinicaPanel {...data.clinica.panel} />
          </div>
        ) : null}
      </FinanceiroTabs>
    </div>
  );
}
